module.exports = __webpack_public_path__ + "static/media/rajesh.f0d020e9.png";